// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './less/index.less'

import './lib/mint-ui'
import 'mint-ui/lib/style.css'
import filters from './filter/index'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
Vue.use(filters)


Vue.config.productionTip = false
NProgress.configure({
    easing: 'ease',  // 动画方式
    speed: 500,  // 递增进度条的速度
    showSpinner: false, // 是否显示加载ico
    trickleSpeed: 200, // 自动递增间隔
    minimum: 0.3 // 初始化时的最小百分比
})
router.beforeEach((to,form, next) => {
    if(to.meta.title){
        document.title = to.meta.title
    }
    next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js